import React from 'react';

export default function Sidebar({ children }) {
  return <nav className="bg-gray-100 h-full w-full">{children}</nav>;
}
